import React from 'react';
import { RootLayout } from './src/components/RootLayout';

export const wrapRootElement = ({ element }) => <RootLayout>{element}</RootLayout>;
